export enum CompanyUserStatus {
  ACTIVE = 'Active',
  DEACTIVATED = 'Deactivated',
  INVITED = 'Invited',
}
